module.exports = __webpack_public_path__ + "img/send-redaction.5cdf2f64.svg";